<template>
	<div id="additionally-insureds">
		<div id="ai-table">
			<div class="mb-4">
				<b-button v-b-modal.request-ai variant="success" @click="editingAi = null">Add Additional Insured</b-button>

				<b-modal
					id="request-ai"
					ref="request-ai"
					size="lg"
					modal-class="no-footer"
					title="Add Additional Insured"
					hide-footer
					lazy
					:no-close-on-backdrop="! editingAi"
					:no-close-on-esc="! editingAi"
					header-bg-variant="dark"
					body-bg-variant="dark">
					<a-i-form
						new-application
						:additionally-insured="editingAi"
						@submitted="$refs['request-ai'].hide(); editingAi = null" />
				</b-modal>
			</div>
			<template v-if="totalRows">
				<b-table
					ref="AITable"
					hover
					outlined
					dark
					:items="additionally_insured"
					:fields="fields"
					:current-page="currentPage"
					:per-page="perPage"
					:filter="filter"
					:filter-included-fields="filterOn"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					:sort-direction="sortDirection"
					stacked="md">
					<template #cell(name)="{ item }">
						<div>{{ item.name }}</div>
					</template>
					<template #cell(address)="{ item }">
						<div v-if="item.address">
							<strong>{{ item.address }}</strong><br />
							{{ item.city }}
							{{ item.state }},
							{{ item.zip }},
							{{ item.country }}
						</div>
						<em v-else class="text-grey">No Address</em>
					</template>
					<template #cell(actions)="{ item }">
						<b-button-group>
							<b-button v-b-tooltip.hover
								variant="warning"
								title="Edit"
								size="sm"
								class="text-white"
								@click="editAi(item)">
								<font-awesome-icon :icon="['fas', 'pen']" />
							</b-button>

							<delete-button
								v-b-tooltip.hover
								title="Delete"
								prefix=""
								model="application-ai"
								:model-id="item.id"
								:only="['additionally_insured']"
								variant="danger"
								size="sm">
								<font-awesome-icon :icon="['fas', 'trash']" />
							</delete-button>
						</b-button-group>
					</template>
				</b-table>
				<b-pagination
					v-if="totalRows > perPage"
					v-model="currentPage"
					:total-rows="totalRows"
					:per-page="perPage"></b-pagination>
			</template>
		</div>
	</div>
</template>
<script>
import AIForm from '@/Pages/AdditionallyInsured/Form'
import DeleteButton from '@/Component/DeleteButton'

export default {
	components: { DeleteButton, AIForm },
	props: {
		//
	},
	data () {
		return {
			loading: false,
			fields: [
				{
					label: 'Contact Name',
					key: 'name',
					class: 'max-width'
				},
				{
					label: 'Address',
					key: 'address',
					class: 'text-nowrap'
				},
				{
					label: 'Relationship',
					key: 'relationship'
				},
				{
					label: '',
					key: 'actions',
					class: 'text-right'
				}
			],
			totalRows: 0,
			additionally_insured: [],
			currentPage: 1,
			perPage: 15,
			pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			editingAi: null
		}
	},
	watch: {
		additionally_insured () {
			this.totalRows = this.length(this.additionally_insured)
		},
		'$page.props.additionally_insured' () {
			this.additionally_insured = this.$page.props.additionally_insured
		}
	},
	mounted () {
		this.$inertia.reload({
			'only': ['additionally_insured'],
			onFinish: () => {
				this.additionally_insured = this.$page.props.additionally_insured
				this.totalRows = this.length(this.additionally_insured)
			}
		})
	},
	methods: {
		editAi (ai) {
			this.editingAi = ai
			this.$refs['request-ai'].show()
		}
	}
}
</script>
